import { render, staticRenderFns } from "./ScoutResumeCardAvatar.vue?vue&type=template&id=c6bdea16&scoped=true"
import script from "./ScoutResumeCardAvatar.vue?vue&type=script&lang=js"
export * from "./ScoutResumeCardAvatar.vue?vue&type=script&lang=js"
import style0 from "./ScoutResumeCardAvatar.vue?vue&type=style&index=0&id=c6bdea16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bdea16",
  null
  
)

export default component.exports